import React from "react";
import styled from "styled-components";

import Product from "./Product";

interface GridViewProps {
  itemCount: number;
}

const GridView = (props: any) => {
  const { products } = props;

  return (
    <Wrapper itemCount={products.length}>
      <div className="products-container">
        {products.map((product: any) => {
          return <Product key={product.id} {...product} />;
        })}
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.section<GridViewProps>`
  .products-container {
    display: grid;
    gap: 6rem 1.5rem;
  }

  @media (min-width: 992px) {
    .products-container {
      grid-template-columns: repeat(2, 360px);
      grid-template-rows: ${(p) =>
        `repeat(${Math.ceil(p.itemCount / 4)}, 360px)`};
    }
  }
  @media (min-width: 1170px) {
    .products-container {
      grid-template-columns: repeat(4, 18vw);
      grid-template-rows: ${(p) =>
        `repeat(${Math.ceil(p.itemCount / 4)},  18vw)`};
    }
  }
`;

export default GridView;
